export const ChatbotCookiePrefix: string = 'OTAChatBot'

export const JwtCookie: string = 'jwt_hp'
export const ChatIdCookie: string = `${ChatbotCookiePrefix}-chatId`
export const ChatNextLocale: string = `NEXT_LOCALE`
export const OTALocale: string = `ota-locale`
export const OTATestVariant: string = `ota-test`
